import { useQuery } from '@tanstack/react-query';
import { getAppDetail } from 'api/appManager';
import { LIST_APP_DETAIL_QUERY } from 'constants/QueryString';

const useAppDetailQuery = (query) => {
  const { data, isLoading, refetch, error } = useQuery({
    queryKey: [LIST_APP_DETAIL_QUERY, query],
    queryFn: async () => {
      try {
        return await getAppDetail(query);
      } catch (error) {
        throw error;
      }
    },
    enabled: !!query.appId,
  });

  return {
    data,
    isLoading,
    refetch,
    error,
  };
};

export default useAppDetailQuery;